import React from 'react'
import ListItem from '../presents/ListItem'
import hasDisplayTimes from '../functions/hasDisplayTimes'
import isOutOfRange from '../functions/isOutOfRange'
import { MOVIE } from '../../../constants/itemTypes'
import ListItemNoDataContainer from './ListItemNoDataContainer'

const ListItemMovieContainer = ({
    itemType=MOVIE,
    itemData,
    additionalClass,
    isSelected,
    additionalButton='',
    pathnameEdit,
    onDelete,
}) => {
    if(!itemData) {
        return <ListItemNoDataContainer onDelete={onDelete} />
    }

    const { title, images, tempPyMoviePoster, titleDisplay, released } = itemData
    const currentTitle = titleDisplay ? titleDisplay : title
    const releasedClass = !itemData.hasOwnProperty('released') ? '' : released ? '' : ' not-released'

    const hasTimes = hasDisplayTimes(itemData)
    const outRange = hasTimes && isOutOfRange(itemData)

    let backgroundImage = 'none'

    if(images && images.poster && images.poster.url) {
        backgroundImage = `url(${images.poster.url})` 
    } else if(tempPyMoviePoster) {
        backgroundImage = `url(${tempPyMoviePoster})`
    }

    const styles = {
        backgroundImage: backgroundImage
    }

    return <ListItem
        title={currentTitle}
        styles={styles}
        type={itemType}
        additionalClass={additionalClass + releasedClass}
        isSelected={isSelected}
        hasDisplayTimes={hasTimes}
        isOutOfRange={outRange}
        additionalButton={additionalButton}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default ListItemMovieContainer